import { Routes } from '@angular/router';
import { DevelopmentComponent } from './web/development/development.component';
import { HomeComponent } from './web/home/home.component';
import { ProyectoDetalleComponent } from './web/proyecto-detalle/proyecto-detalle.component';
import { AMedidaComponent } from './web/a-medida/a-medida.component';
// import { TrasterosComponent } from './web/trasteros/trasteros.component'; // ruta /trasteros desactivada
import { Error404Component } from './web/error404/error404.component';
import { TemplateComponent } from './web/plantilla/template/template.component';
import { FiscalComponent } from './web/fiscal/fiscal.component';
import { ContactoComponent } from './web/contacto/contacto.component';
import { StartComponent } from './web/start/start.component';
import { pageDataResolver } from './services/page-data.resolver';
import { ProductsContractedTestComponent } from './web/home/products-contracted-test.component';
import { PagoLibreComponent } from './web/pago-libre/pago-libre.component';
import { ProductosComponent } from './web/productos/productos.component';
import { PreciosComponent } from './web/precios/precios.component';
import { SolucionesComponent } from './web/soluciones/soluciones.component';
import { ModulosComponent } from './web/modulos/modulos.component';
import { SolucionDetalleComponent } from './web/soluciones/solucion-detalle.component';

export const routes: Routes = [
  // {
  //   path: '',
  //   component: StartComponent,
  //   pathMatch: 'full',
  // },
  {
    path: 'mantenimiento',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: DevelopmentComponent,
      },
    ],
  },
  {
    path: '',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        data: {
          sectionType: 1, // Tipo 1 para home
          seo: {
            title: 'Software de gestión modular para pymes y autónomos',
            description:
              'Fichaje con operativos ilimitados y facturación en regla, conectados. Empieza por la base y crece según tu sector; y lo que el estándar no cubre, lo desarrollamos a medida. Sin pagar por lo que no usas.',
            path: '/',
          },
        },
        resolve: {
          pageData: pageDataResolver,
        },
      },
    ],
  },

  {
    path: 'test-product',
    component: TemplateComponent,
    children: [{ path: '', component: ProductsContractedTestComponent }],
  },

  {
    path: 'a-medida',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: AMedidaComponent,
        data: {
          seo: {
            title: 'Desarrollos a medida',
            description:
              'Software real a medida, funcionando hoy: gestores de obra, portales de expedientes, plataformas de seguros y más, construidos sobre la plataforma TodoSector sin migrar tus datos.',
            path: '/a-medida',
          },
        },
      },
    ],
  },
  {
    path: 'a-medida/:slug',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: ProyectoDetalleComponent,
      },
    ],
  },
  // URLs antiguas /proyectos → /a-medida (el 301 real lo hace server.ts).
  { path: 'proyectos', redirectTo: 'a-medida', pathMatch: 'full' },
  { path: 'proyectos/:slug', redirectTo: 'a-medida/:slug' },
  // Ruta /trasteros desactivada (no debe existir por ahora). Se conservan los
  // componentes (trasteros, storage-room-plan…) como referencia para futuros
  // desarrollos. Reactivar descomentando este bloque.
  // {
  //   path: 'trasteros',
  //   component: TemplateComponent,
  //   children: [
  //     {
  //       path: '',
  //       component: TrasterosComponent,
  //     },
  //   ],
  // },
  {
    path: 'contacto',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: ContactoComponent,
        data: {
          seo: {
            title: 'Contacto',
            description:
              'Cuéntanos qué necesitas: comercial, soporte o desarrollo a medida. Te responderemos lo antes posible. Palma de Mallorca.',
            path: '/contacto',
          },
        },
      },
    ],
  },

  {
    path: 'cookies',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/cookies/cookies.component').then(
            r => r.CookiesComponent
          ),
        data: { sectionType: 2 },
        resolve: { pageData: pageDataResolver },
      },
    ],
  },
  // {
  //   path: 'pago',
  //   component: TemplateComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadComponent: () =>
  //         import('./web/pago/pago.component').then(r => r.PagoComponent),
  //     },
  //   ],
  // },
  {
    path: 'prueba-sin-compromiso',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/prueba/prueba.component').then(r => r.PruebaComponent),
        data: {
          seo: {
            title: 'Prueba de 14 días',
            description:
              'Configura tu prueba de 14 días: elige los módulos que quieres probar y crea tu cuenta con ellos ya activos. Sin tarjeta ni permanencia.',
            path: '/prueba-sin-compromiso',
          },
        },
      },
    ],
  },
  // URLs antiguas de la prueba → redirección (el 301 real lo hace server.ts).
  {
    path: 'prueba-gratis',
    redirectTo: 'prueba-sin-compromiso',
    pathMatch: 'full',
  },
  {
    path: 'contratar',
    redirectTo: 'prueba-sin-compromiso',
    pathMatch: 'full',
  },
  {
    path: 'pago-libre',
    component: TemplateComponent,
    children: [{ path: '', component: PagoLibreComponent }],
  },
  {
    path: 'servicios',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: ProductosComponent,
        data: {
          seo: {
            title: 'Servicios',
            description:
              'Desarrollo de software a medida, desarrollo web y hosting gestionado para tu empresa.',
            path: '/servicios',
          },
        },
      },
    ],
  },
  {
    path: 'modulos',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: ModulosComponent,
        data: {
          seo: {
            title: 'Módulos',
            description:
              'Activa solo los módulos que necesitas: facturación, clientes, proyectos, gastos con IA, fichaje y más. Módulos que funcionan solos y complementos que los potencian.',
            path: '/modulos',
          },
        },
      },
    ],
  },
  {
    path: 'precios',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: PreciosComponent,
        data: {
          seo: {
            title: 'Precios y planes',
            description:
              'Pack base desde 45 €/mes con usuarios operativos ilimitados: no cobramos licencia por quien solo ficha. Suma módulos desde 8 €/mes.',
            path: '/precios',
          },
        },
      },
    ],
  },
  {
    path: 'verifactu',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/verifactu/verifactu.component').then(
            r => r.VerifactuComponent
          ),
        data: {
          seo: {
            title: 'Verifactu, resuelto',
            description:
              'Factura como siempre y cumple Verifactu sin pensar en ello: facturas conformes de serie, transición suave desde el Excel y actualización automática ante cada cambio normativo.',
            path: '/verifactu',
          },
        },
      },
    ],
  },
  {
    path: 'soluciones',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: SolucionesComponent,
        data: {
          seo: {
            title: 'Soluciones por sector',
            description:
              'La solución ya montada para tu sector: construcción, servicios técnicos, gestorías, comercio, trasteros y restauración. Módulos preseleccionados, precio desglosado y desarrollo a medida.',
            path: '/soluciones',
          },
        },
      },
    ],
  },
  {
    path: 'soluciones/:slug',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: SolucionDetalleComponent,
        data: {
          seo: {
            title: 'Solución por sector',
            description:
              'El detalle de cada solución por sector: qué trae preseleccionado, el precio desglosado y cómo queda tu día a día.',
          },
        },
      },
    ],
  },
  {
    path: 'ayuda',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/ayuda/ayuda-index/ayuda-index.component').then(
            r => r.AyudaIndexComponent
          ),
        data: {
          seo: {
            title: 'Centro de ayuda',
            description:
              'Manuales y guías de uso de TodoSector: configura y exprime cada módulo paso a paso.',
            path: '/ayuda',
          },
        },
      },
      {
        path: 'categoria/:slug',
        loadComponent: () =>
          import(
            './web/ayuda/ayuda-categoria/ayuda-categoria.component'
          ).then(r => r.AyudaCategoriaComponent),
        data: {
          seo: {
            title: 'Centro de ayuda',
            description:
              'Guías y manuales de TodoSector por categoría.',
          },
        },
      },
      {
        path: ':slug',
        loadComponent: () =>
          import('./web/ayuda/ayuda-articulo/ayuda-articulo.component').then(
            r => r.AyudaArticuloComponent
          ),
        data: {
          seo: {
            title: 'Centro de ayuda',
            description:
              'Manual de uso de TodoSector.',
          },
        },
      },
    ],
  },
  {
    path: 'pago/resultado',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/pago-resultado/pago-resultado.component').then(
            r => r.PagoResultadoComponent
          ),
      },
    ],
  },
  {
    path: 'aviso-legal',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/aviso-legal/aviso-legal.component').then(
            r => r.AvisoLegalComponent
          ),
        data: { sectionType: 2 },
        resolve: { pageData: pageDataResolver },
      },
    ],
  },
  {
    path: 'privacidad',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/politica-privacidad/politica-privacidad.component').then(
            r => r.PoliticaPrivacidadComponent
          ),
        data: { sectionType: 3 },
        resolve: { pageData: pageDataResolver },
      },
    ],
  },
  // Destino de enlaces de acceso expirados (flujo de prueba). Los emails y el
  // backend pueden redirigir aquí; no entra en el sitemap y lleva noindex.
  {
    path: 'enlace-caducado',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/enlace-caducado/enlace-caducado.component').then(
            r => r.EnlaceCaducadoComponent
          ),
        data: {
          seo: {
            title: 'Enlace caducado',
            description:
              'Por seguridad, los enlaces de acceso dejan de funcionar pasado un tiempo.',
            path: '/enlace-caducado',
          },
        },
      },
    ],
  },
  // Vista previa de una cms_page (incluye borradores). Protegida por token en el
  // servidor (server.ts /preview/*). Debe ir antes de ':slug'.
  {
    path: 'preview/:slug',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/cms-page/cms-page-render.component').then(
            r => r.CmsPageRenderComponent
          ),
        data: { preview: true },
      },
    ],
  },
  // Páginas dinámicas del CMS (cms_page) por slug de un solo segmento.
  // Debe ir penúltima: las rutas estáticas de arriba tienen prioridad; si ninguna
  // casa, intenta resolver una página publicada y, si no existe, muestra 404.
  {
    path: ':slug',
    component: TemplateComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./web/cms-page/cms-page-render.component').then(
            r => r.CmsPageRenderComponent
          ),
      },
    ],
  },
  {
    path: '**',
    component: TemplateComponent,
    children: [
      {
        path: '',
        component: Error404Component,
        data: {
          seo: {
            title: 'Página no encontrada',
            description:
              'La página que buscas no existe, ha cambiado de dirección o aún no está publicada.',
          },
        },
      },
    ],
  },
];
